import * as PayrollAna2Selectors from './payroll.ana2.selectors';
import * as PayrollAnalyticsSelectors from './payroll.analytics.selectors';
import * as PayrollSyntheseSelectors from './payroll.synthese.selectors';
import * as PayrollRuleSelectors from './payroll.rule.selectors';
import * as PayrollExtraSelectors from './payroll.extra.selectors';
import * as PayrollSelectors from './payroll.selectors';
import * as PayrollUISelectors from './payroll.ui.selectors';

export {
  PayrollSelectors,
  PayrollUISelectors,
  PayrollExtraSelectors,
  PayrollRuleSelectors,
  PayrollSyntheseSelectors,
  PayrollAnalyticsSelectors,
  PayrollAna2Selectors
};
